export default __webpack_public_path__ + "static/media/android-arrow-back.9230a43e5a80789f1de31accd3a185c2.svg";